<script>
import {mapGetters, mapActions} from 'vuex'
import {ERROR_GENERIC} from '../../utils/messages'
import response from '../../fake/spese-accessorie-response'
import {FAKE_ACTIVE, WS_URL} from '../../utils/config'
import Vue from 'vue'
// import {PRODUCT_TOUR} from '../../types/products'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'
import {isSameDate} from '../../utils/helper'
import ConfigUtils from '../utils/ConfigUtils'

export default {
  name: 'CaricaPraticaAction',
  mixins: [ConfigUtils],
  methods: {
    ...mapGetters(['hasArrivalServiceTransfer', 'getFlightArrivalServiceTransfer', 'getSearch', 'getFlightFrom', 'getFlightsFrom', 'getFlightTo', 'getFlightsTo', 'getSpeseAccessorie', 'getServiziSelected', 'getTrasferimentiSelected', 'getSelectedHotels', 'getSelectedTour']),
    ...mapActions(['loadingStart', 'loadingEnd', 'loadSpeseAccessorie']),
    caricaPratica () {
      return FAKE_ACTIVE ? this.caricaPraticaFake() : this.caricaPraticaReal()
    },
    caricaPraticaReal () {
      const search = this.getSearch()
      const flight = this.getFlightFrom()
      const serviziItems = this.makeServiceData(search)
      const hotelsItems = this.makeHotelData(search)
      const tourItems = this.makeTourData(search)
      const camere = search.camere.map(function (item, index) {
        return {id: index + 1, adults: item.adults, childs: item.childs}
      })
      const payload = {
        fromDate: this.$moment(search.andata ? search.andata : search.partenza).format(SERVER_DATE_FORMAT),
        travelGroup: camere,
        flightItemId: flight.itemId,
        serviziItems,
        hotelsItems,
        tourItems,
        hotelSearchLocality: this.HOTEL_SEARCH_LOCALITY
      }
      this.loadingStart()
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${WS_URL}pratica`, payload, {withCredentials: true}).then(response => {
          const data = response.data
          if (!data.done && data.messages) {
            const messages = data.messages.map(item => item.message)
            this.$toastr.error(messages.toString())
            const error = {error: true, messages: data.messages}
            reject(error)
          } else if (data.actionPreventivo && !data.actionPreventivo.done && data.actionPreventivo.messages) {
            const messages = data.actionPreventivo.messages.map(item => item.message)
            this.$toastr.error(messages.toString())
            const error = {error: true, messages: data.messages}
            reject(error)
          } else {
            this.loadSpeseAccessorie(data)
            resolve(response)
          }
        }).catch((error) => {
          this.$toastr.error(ERROR_GENERIC)
          reject(error)
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    caricaPraticaFake () {
      return new Promise((resolve) => {
        this.loadSpeseAccessorie(response)
        resolve('success')
      })
    },
    makeServiceData () {
      let list = []
      let services = []
      // aggiunge l'eventuale servizio notte in caso di arrivo il giorno successivo
      if (this.hasArrivalServiceTransfer()) {
        services.push(this.getFlightArrivalServiceTransfer())
      }
      // aggiunge i servizi selezionati
      services = services.concat(this.getServiziSelected())
      // aggiunge i trasferimenti
      services = services.concat(this.getTrasferimentiSelected())
      services.forEach(service => {
        // estraggo i gruppi selezionati a true
        const groupsSelected = service.groups.filter(group => group.selected)
        // per ogni gruppo selezionato estraggo i prezzi selezionati per quel giorno per quel gruppo
        groupsSelected.forEach(group => {
          // estraggo i prezzi del giorno
          const priceByDay = service.pricesByDay.find(price => isSameDate(price.day, group.dateSelected))
          if (priceByDay == null) return
          // estraggo i prezzi del giorno per lo specifico gruppo
          const priceByGroup = priceByDay.prices.find(item => item.group === group.id)
          if (priceByGroup == null) return
          const priceFound = priceByGroup.prices[0]
          const prices = priceByDay.prices.map(item => item.prices[0])
          list.push(
            {
              itemToInsert: {
                productId: service.detail.productID,
                itemId: priceFound.itemId,
                travellerGroup: {
                  id: priceFound.groupId
                }
              },
              detailResponse: {
                prices
              }
              /*
              detailResponse: {
                detail: service.detail,
                done: true,
                notes: service.notes,
                prices
              }
              */
            })
        })
      })
      return list
    },
    makeHotelData () {
      let list = []
      this.getSelectedHotels().forEach(item => {
        item.groups.forEach(group => {
          const roomSelected = group.rooms.find(item => item.selected)
          list.push(
            {
              itemToInsert: {
                itemId: roomSelected ? roomSelected.itemId : null,
                travellerGroup: {
                  id: group.travelGroupId
                }
              },
              hotelAvailability: {
                rooms: group.rooms,
                hotel: item.hotel,
                reparto: item.reparto,
                idreparto: item.idreparto
              }
            }
          )
        })
      })
      return list
    },
    makeTourData (search) {
      const tour = this.getSelectedTour()
      if (!tour) return []
      let list = []
      tour.detailResponses.forEach(detailResponse => {
        const idReparto = detailResponse.detail.idReparto
        const productID = detailResponse.detail.productID
        const dateFrom = tour.date
        const product = {idReparto, productID, dateFrom}
        const travellerGroupId = detailResponse.travelGroupId
        const price = detailResponse.prices.find(item => item.selected === true)
        list.push(
          {
            product,
            category: {
              categoryID: price.categoryID,
              category: price.category
            },
            travellerGroup: {
              id: travellerGroupId
            },
            tipo: 'Tour',
            catalogo: product
          }
        )
      })
      return list
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/CaricaPraticaAction.vue